import React, { FC } from "react";
import { Container, Row, Col } from "react-bootstrap";

import Heading from "../../Shared/Common/Heading";
import SimpleImage from "../../Shared/Media/SimpleImage";
import ReNissanImg from "../../../assets/images/ReNissan.webp";
import { FormattedMessage } from "react-intl";
import { AnchorButton } from "../../Shared/Common/Anchor/Button";

const ReNissan: FC = () => {
  return (
    <div className="re-nissan-area">
      <Container>
        <Row>
          <Col sm={12} md={12} lg={6}>
            <SimpleImage src={ReNissanImg} />
          </Col>
          <Col sm={12} md={12} lg={6} className="re-nissan-cont">
            <Row className="pb-4">
              <Heading type="section-heading">
                <FormattedMessage id={"page.career_area.re_nissan.title"} />
              </Heading>
            </Row>
            <p>
              <FormattedMessage
                id={"page.career_area.re_nissan.description"}
                values={{ br: <br /> }}
              />
            </p>
            <div className="d-flex">
              <AnchorButton
                href="https://www.nissan-global.com/EN/COMPANY/PLAN/RENISSAN/"
                href_jp="https://www.nissan-global.com/JP/COMPANY/PLAN/RENISSAN/"
                external={true}
                variant={"primary-outline"}
              >
                <FormattedMessage id={"page.common.learn_more"} />
              </AnchorButton>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};
export default ReNissan;
